import { FC } from "react";
import { TextFieldProps } from "./TextField.constant";
import { Controller } from "react-hook-form";
import { FormFeedback, Input } from "reactstrap";

const TextField: FC<TextFieldProps> = ({
  control,
  name,
  className,
  value,
  type,
  defaultValue,
  id,
  placeholder,
  error,
  setPasswordShow,
  passwordEye = false,
}) => {
  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({ field }) => {
        const onPasswordEyeHandler = (value: boolean) => {
          setPasswordShow && setPasswordShow(value);
        };
        return (
          <>
            <Input
              {...field}
              variant="standard"
              className={className}
              placeholder={placeholder}
              id={id}
              autoComplete="off"
              defaultValue={defaultValue}
              value={value}
              type={type}
              invalid={!!error}
            />

            {passwordEye && (
              <button
                onTouchStart={() => onPasswordEyeHandler(true)}
                onTouchEnd={() => onPasswordEyeHandler(false)}
                onMouseDown={() => onPasswordEyeHandler(true)}
                onMouseUp={() => onPasswordEyeHandler(false)}
                className="btn btn-light shadow-none ms-0"
                type="button"
                id="password-addon"
              >
                <i className="mdi mdi-eye-outline"></i>
              </button>
            )}

            {!!error && error ? (
              <FormFeedback type="invalid">{error}</FormFeedback>
            ) : (
              <div style={{ height: "22.5px", width: "100%" }}> </div>
            )}
          </>
        );
      }}
    />
  );
};

export default TextField;
